var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTodayIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7354 2.22932C14.7354 1.06363 13.7904 0.118652 12.6247 0.118652H2.55843C1.39273 0.118652 0.447754 1.06363 0.447754 2.22932V12.2956C0.447754 13.4613 1.39273 14.4063 2.55843 14.4063H6.45395C6.45395 14.4063 6.45505 14.0935 6.45505 13.9192V13.4321H2.55843C1.93074 13.4321 1.42191 12.9233 1.42191 12.2956V4.34194H13.7612V12.2956C13.7612 12.9233 13.2524 13.4321 12.6247 13.4321H8.72808V13.9192C8.72808 14.0935 8.72808 14.4063 8.72808 14.4063H12.6247C13.7904 14.4063 14.7354 13.4613 14.7354 12.2956V2.22932ZM2.55843 1.09281H12.6247C13.2524 1.09281 13.7612 1.60164 13.7612 2.22932V3.36779H1.42191V2.22932C1.42191 1.60164 1.93074 1.09281 2.55843 1.09281Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.4024 6.77566C8.4024 7.22404 8.03898 7.58746 7.59061 7.58746C7.14223 7.58746 6.77881 7.22404 6.77881 6.77566C6.77881 6.32729 7.14223 5.96387 7.59061 5.96387C8.03898 5.96387 8.4024 6.32729 8.4024 6.77566Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.72806 11.3614C8.92912 11.5401 9.23702 11.5221 9.41568 11.321C9.5944 11.12 9.57635 10.8121 9.37529 10.6333L7.91405 9.33446C7.72948 9.17041 7.45139 9.17041 7.26682 9.33446L5.80559 10.6333C5.60452 10.8121 5.5864 11.12 5.76513 11.321C5.94385 11.5221 6.25175 11.5401 6.45282 11.3614L7.10336 10.7832V14.5693C7.10336 14.8383 7.32144 15.0564 7.59044 15.0564C7.85943 15.0564 8.07751 14.8383 8.07751 14.5693V10.7832L8.72806 11.3614Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTodayIcon);
export default __webpack_public_path__ + "static/media/today-icon.6533b4bc5c514678c63738c7005072bb.svg";
export { ForwardRef as ReactComponent };